import TinyInputStore from '../../components/tiny-input/store';
import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import lockAsync from '../../utils/lock-async';
import captchaHandlerDecorate from '../../utils/captcha-deco-util';
import { useRequest } from 'ahooks';
import { message } from 'antd';

/**
 * sendCodeAsync例如:
 * const sendCodeAsync = params => {
 * return $ztService.getPhoneCode({
 *  ...params
 * });
 *};
 *
 * 业务new store使用参考:
 * phoneCodeInputStore = new PhoneCodeInputStore({ sendCodeAsync: sendCodeAsync });
 */
class PhoneCodeInputStore {
  /**
   * 发送验证码接口
   *  注: 需要外部传入的业务接口
   */
  @observable sendCodeAsync;

  /**
   * 手机号码输入框
   * @type {*}
   */
  phoneInputStore = new TinyInputStore();

  /**
   * 验证码输入框
   * @type {TinyInputStore}
   */
  smsInputStore = new TinyInputStore();

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    try {
      await this.sendCodeRequest.run({ ...authParams });
      message.success('验证码已发送, 请注意查收');
      return true;
    } catch (err) {
      message.error(err.message);
      return false;
    }
  }

  constructor({ sendCodeAsync, ...rest } = {}) {
    this.sendCodeAsync = sendCodeAsync;
    Object.assign(this, rest);
  }

  use() {
    /**
     * 获取验证码接口
     */
    this.sendCodeRequest = useRequest(async params => await this.sendCodeAsync(params), { manual: true, throwOnError: true });
  }
}
export default PhoneCodeInputStore;
